/* ==========================================================================
   Joeps storefront - global interactions (vanilla, no dependencies, deferred).
   Sticky header · mobile drawer · AJAX add-to-cart · cart qty · filter drawer.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- Sticky header shadow ---------------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile nav drawer + PLP filter drawer ----------------------------- */
  var drawer = document.querySelector('[data-drawer]');
  var laatsteFocus = null;
  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* De lade zegt role="dialog" aria-modal="true", maar nam de focus niet mee:
       met het toetsenbord tabde je door de pagina achter de overlay. Focus naar
       binnen, vasthouden, en bij sluiten terug naar waar je vandaan kwam. */
    laatsteFocus = document.activeElement;
    var eerste = drawer.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (eerste) eerste.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    var f = [].slice.call(drawer.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var eerste = f[0], laatste = f[f.length - 1];
    if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  });
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    /* Melden dat de lade dicht is. De submenu-stapel werd alleen teruggezet bij
       een klik op het kruisje of de achtergrond, niet bij Escape; wie daarna
       opnieuw opende, stond midden in een submenu. */
    document.dispatchEvent(new CustomEvent('jp:drawer-dicht'));
    if (laatsteFocus && laatsteFocus.focus) { laatsteFocus.focus(); laatsteFocus = null; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); }
    var ft = e.target.closest('[data-filter-toggle]');
    if (ft) {
      var f = document.querySelector('[data-filters]');
      if (f) {
        var open = f.getAttribute('data-open') === 'true';
        f.setAttribute('data-open', open ? 'false' : 'true');
        document.body.style.overflow = open ? '' : 'hidden';
        document.body.classList.toggle('filters-open', !open);
        /* De dimming rechtstreeks zetten. Via de stylesheet kwam alleen
           pointer-events door en de achtergrondkleur niet, en een scherm dat
           klikken opvangt maar niets laat zien is verwarrender dan geen scherm. */
        var scrim = document.querySelector('.filters__scrim');
        if (scrim) scrim.style.background = open ? '' : 'rgba(10, 26, 43, .45)';
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); var f = document.querySelector('[data-filters]'); if (f) { f.setAttribute('data-open', 'false'); document.body.style.overflow = ''; document.body.classList.remove('filters-open'); var sc = document.querySelector('.filters__scrim'); if (sc) sc.style.background = ''; } } });

  /* ---- Cart count badge -------------------------------------------------- */
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          if (c.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
          var link = el.closest('a.site-action');
          if (link) link.setAttribute('aria-label', 'Winkelwagen' + (c.item_count > 0 ? ' (' + c.item_count + ')' : ''));
        });
      }).catch(function () {});
  }
  window.__joepsCartCount = refreshCartCount;

  /* ---- Lightweight toast ------------------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:var(--navy-900);color:#fff;padding:12px 20px;border-radius:12px;font-weight:700;font-size:14px;box-shadow:0 10px 28px rgba(10,26,43,.3);z-index:200;opacity:0;transition:opacity .2s,transform .2s;pointer-events:none';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.style.opacity = '1'; toastEl.style.transform = 'translateX(-50%) translateY(0)'; });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.style.opacity = '0'; toastEl.style.transform = 'translateX(-50%) translateY(20px)'; }, 2200);
  }
  window.__joepsToast = toast;

  /* Shopify zet bij een geweigerde toevoeging de leesbare reden in het veld
     description van het 422-antwoord. Die werd nergens gelezen; de klant werd
     zonder uitleg naar /cart gestuurd. Nu vertellen we wat er misging en
     blijft hij waar hij is. */
  function meldFout(res, terugval) {
    return res.json().then(function (j) {
      toast((j && (j.description || j.message)) || terugval || 'Dat lukte niet, probeer het opnieuw');
    }).catch(function () { toast(terugval || 'Dat lukte niet, probeer het opnieuw'); });
  }

  /* ---- AJAX add-to-cart (progressive enhancement of [data-cart-add]) ----- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (res) {
        if (!res.ok) { return meldFout(res); }
        return res.json().then(function () { return refreshCartCount(); }).then(function () { toast(form.getAttribute('data-added-text') || 'Toegevoegd aan winkelwagen'); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* ---- Quick add-to-cart from product cards ([data-quick-add] button) ----- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    qa.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      /* data-quick-gift draagt de cadeauregel mee zodat wie via de productkaart
         bestelt dezelfde regel op de bestelling krijgt als wie via de
         productpagina bestelt. Zonder dit zou dat per route verschillen. */
      body: JSON.stringify({ items: (function () {
        var hoofd = { id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 };
        var cadeau = qa.getAttribute('data-quick-gift');
        if (cadeau) hoofd.properties = { 'Gratis erbij': cadeau };
        var lijst = [hoofd];
        (qa.getAttribute('data-quick-free') || '').split(',').forEach(function (v) {
          var id = parseInt(v, 10);
          if (id) lijst.push({ id: id, quantity: 1 });
        });
        return lijst;
      })() })
    }).then(function (res) {
      if (!res.ok) { return meldFout(res); }
      return res.json().then(function () { return refreshCartCount(); }).then(function () { toast('Toegevoegd aan winkelwagen'); });
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { qa.removeAttribute('aria-disabled'); });
  });

  /* ---- Cart page: quantity steppers + line updates ----------------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.parentElement;
    var input = wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v = step.getAttribute('data-qty-step') === 'up' ? v + 1 : Math.max(0, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = input.getAttribute('data-cart-qty');
    var oudAantal = input.getAttribute('data-vorig') || input.defaultValue || input.value;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
    }).then(function (r) {
      if (!r.ok) { return meldFout(r, 'Het aantal kon niet worden bijgewerkt'); }
      return r.json().then(function () { window.location.reload(); });
    }).catch(function () {
      /* Zonder deze vangst bleef het nieuwe aantal op het scherm staan terwijl
         de winkelwagen niet was bijgewerkt: de klant denkt dat het gelukt is. */
      input.value = oudAantal;
      toast('Het aantal kon niet worden bijgewerkt, probeer het opnieuw');
    });
  });

  /* ---- Accordions (single-open, animated height) ------------------------- */
  function setPanelHeight(item, open) {
    var panel = item.querySelector('.jp-acc__panel');
    if (!panel || !panel.firstElementChild) return;
    panel.style.height = open ? panel.firstElementChild.scrollHeight + 'px' : '0px';
  }
  document.querySelectorAll('[data-accordion-item]').forEach(function (it) {
    if (it.getAttribute('data-open') === 'true') setPanelHeight(it, true);
  });
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-accordion-trigger]');
    if (!trig) return;
    var acc = trig.closest('[data-accordion]');
    var item = trig.closest('[data-accordion-item]');
    var open = item.getAttribute('data-open') === 'true';
    if (!open && acc) {
      acc.querySelectorAll('[data-accordion-item]').forEach(function (it) {
        it.setAttribute('data-open', 'false');
        var b = it.querySelector('[data-accordion-trigger]');
        if (b) b.setAttribute('aria-expanded', 'false');
        setPanelHeight(it, false);
      });
    }
    item.setAttribute('data-open', open ? 'false' : 'true');
    trig.setAttribute('aria-expanded', open ? 'false' : 'true');
    setPanelHeight(item, !open);
  });
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-accordion-item][data-open="true"]').forEach(function (it) { setPanelHeight(it, true); });
  });

  /* ---- Tabs -------------------------------------------------------------- */
  function selectTab(tab) {
    var tabs = tab.closest('[data-tabs]');
    var key = tab.getAttribute('data-tab');
    if (!tabs) return;
    tabs.querySelectorAll('[data-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      t.tabIndex = t === tab ? 0 : -1;
    });
    tabs.parentElement.querySelectorAll('[data-tab-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== key; });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tab]');
    if (tab) selectTab(tab);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-tab]');
    var list = tab && tab.closest('[data-tabs]');
    if (!list) return;
    var tabs = [].slice.call(list.querySelectorAll('[data-tab]'));
    var index = tabs.indexOf(tab);
    if (e.key === 'ArrowRight') index = (index + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') index = 0;
    else if (e.key === 'End') index = tabs.length - 1;
    else return;
    e.preventDefault();
    selectTab(tabs[index]);
    tabs[index].focus();
  });

  /* ---- Collection filters: auto-submit on change ------------------------- */
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-filter-input]');
    if (!inp) return;
    /* Op mobiel niet meteen versturen: daar staat de lade open en wil de klant
       eerst meerdere filters aanvinken. Hij sluit af met 'Toon resultaten',
       en dat is nu een echte verstuurknop. Dezelfde grens als in de CSS. */
    if (window.matchMedia('(max-width: 979px)').matches) return;
    var form = inp.closest('[data-filters-form]');
    if (form) form.submit();
  });

  /* Draait iemand zijn tablet met de filterlade open, dan verdwijnen boven
     979px de sluitknoppen terwijl de scrollvergrendeling blijft staan: de
     pagina zit dan vast en alleen herladen helpt. Bij het passeren van die
     grens de lade en de vergrendeling opheffen. */
  (function () {
    var breed = window.matchMedia('(min-width: 980px)');
    function opheffen(e) {
      if (!e.matches) return;
      var f = document.querySelector('[data-filters]');
      if (f) f.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
      document.body.classList.remove('filters-open');
      var sc2 = document.querySelector('.filters__scrim');
      if (sc2) sc2.style.background = '';
    }
    if (breed.addEventListener) breed.addEventListener('change', opheffen);
    else if (breed.addListener) breed.addListener(opheffen);
  }());
})();
